<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" routerLink={{homePage}}>
        <img [src]="logoSrc" alt="GardeKids" />
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
      <ul class="float-start collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse nav-notification-icons"> <i
              class="material-icons-outlined icon-color">
              menu
            </i></button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button class="nav-notification-icons" (click)="callFullscreen()"> <i
              class="material-icons-outlined icon-color">
              fullscreen
            </i></button>
        </li>
        <!-- #END# Full Screen Button -->
        <!-- #START# Notifications-->
        <li>
          <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons"> <i
              class="material-icons-outlined icon-color">
              notifications_active
            </i></button>
          <mat-menu #notificationMenu="matMenu" class="nfc-menu">
            <div class="nfc-header">
              <h5 class="mb-0">{{ 'HEADER.NOTIFICATIONS' | translate }}</h5>
              <a class="nfc-mark-as-read" (click)="openInbox(); $event.stopPropagation()">{{ 'HEADER.MARK_ALL_READ' | translate }}</a>
            </div>
            <div class="nfc-dropdown">
              <ng-scrollbar style="height: 350px" visibility="hover">
                <div class="noti-list header-menu">
                  <div class="menu">
                    <div>
                      @for (notification of notifications; track notification.messageKey) {
                      <button mat-menu-item (click)="openInbox()" [ngClass]="[notification.status]">
                        <span class="table-img msg-user ">
                          <i class="material-icons-outlined nfc-type-icon"
                            [ngClass]="[notification.color]">{{notification.icon}}</i>
                        </span>
                        <span class="menu-info">
                          <span class="menu-title">{{ notification.messageKey | translate }}</span>
                          <span class="menu-desc mt-2">
                            <i class="material-icons">mail_outline</i>
                          </span>
                        </span>
                      </button>
                      }
                    </div>
                  </div>
                </div>
              </ng-scrollbar>
            </div>
            <div class="nfc-footer">
              <a class="nfc-read-all" (click)="openInbox(); $event.stopPropagation()">{{ 'HEADER.READ_ALL' | translate }}</a>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Notifications-->
        <li class="nav-item">
          <button mat-icon-button [matMenuTriggerFor]="languagemenu" class="lang-dropdown nav-notification-icons"> @if
            (flagvalue !== undefined) {
            <img src="{{flagvalue}}" height="16">
            }
            @if (flagvalue === undefined) {
            <img src="{{defaultFlag}}" height="16">
            }</button>
          <mat-menu #languagemenu="matMenu">
            @for (item of listLang; track item) {
            <div class="lang-item">
              <button mat-menu-item class="dropdown-item lang-item-list"
                (click)="setLanguage(item.text, item.lang, item.flag)"
                [ngClass]="{'active': langStoreValue === item.lang}">
                <img src="{{item.flag}}" class="flag-img" height="12"> <span class="align-middle">{{item.text}}</span>
              </button>
            </div>
            }
          </mat-menu>
        </li>
        <li class="nav-item user_profile">
          <button mat-button [matMenuTriggerFor]="profilemenu">
            <div class="chip dropdown-toggle" ngbDropdownToggle class="pt-0">
              <img src="{{userImg}}" class="user_img" width="32" height="32" alt="User">
              <span>{{userName}}</span>
            </div>
          </button>
          <mat-menu #profilemenu="matMenu" class="profile-menu">
            <div class="noti-list">
              <div class="menu ">
                <div class="user_dw_menu">
                  <button mat-menu-item class="user-item-list" [routerLink]="profileLink">
                    <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>{{ 'HEADER.ACCOUNT' | translate }}
                  </button>
                  <button mat-menu-item class="user-item-list" [routerLink]="changePasswordLink">
                    <app-feather-icons [icon]="'lock'" [class]="'user-menu-icons'"></app-feather-icons>{{ 'HEADER.CHANGE_PASSWORD' | translate }}
                  </button>
                  <button mat-menu-item class="user-item-list" [routerLink]="inboxLink">
                    <app-feather-icons [icon]="'mail'" [class]="'user-menu-icons'"></app-feather-icons>{{ 'HEADER.INBOX' | translate }}
                  </button>
                  <button mat-menu-item (click)="logout()" class="user-item-list">
                    <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>{{ 'HEADER.LOGOUT' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Tasks -->
      </ul>
    </div>
  </div>
</nav>